export interface Selection {
    start: number;
    end: number;
    direction: SelectionDirection;
}

export type SelectionDirection = "forward" | "backward" | "none";

export class SelectionHelper {
    public static fromPosition = (position: number): Selection => ({
        start: position,
        end: position,
        direction: "none",
    });

    public static backward = (start: number, end: number): Selection => ({
        start: start,
        end: end,
        direction: "backward",
    });

    public static forward = (start: number, end: number): Selection => ({
        start: start,
        end: end,
        direction: "forward",
    });
}
